var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  123456fasfa\n  "),_c('div',_vm._l((_vm.list),function(item,i){return _c('span',{key:i},[_vm._v(_vm._s(item+'、'))])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }